import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-signout",
    template: "",
    standalone: false
})
export class SignoutComponent implements OnInit {

    ngOnInit() {
        const url = sessionStorage.getItem("signoutRedirect");
        sessionStorage.removeItem("signoutRedirect");

        if (url && url.length > 0)
            window.location.href = url;
    }

}
